module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-14.f64ee60a.png";